import { render } from "./RatingIndicator.vue?vue&type=template&id=2cdebac6"
import script from "./RatingIndicator.vue?vue&type=script&lang=js"
export * from "./RatingIndicator.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__